import axios, { AxiosResponse } from 'axios';
import { ENDPOINTS } from '@/settings/endpoints';
import { getChimeraToken } from '@/helpers/get-tokens';

export default class TermsOfUseService {
  static async getAccepted(): Promise<AxiosResponse> {
    const response = await axios.request({
      url: ENDPOINTS.termsOfUse,
      headers: {
        Authorization: `Bearer ${getChimeraToken()}`,
      },
    });

    return response;
  }

  static async sendAccepted(): Promise<AxiosResponse> {
    const response = await axios.request({
      method: 'post',
      url: ENDPOINTS.termsOfUse,
      headers: {
        Authorization: `Bearer ${getChimeraToken()}`,
      },
    });

    return response;
  }
}
